<template>
  <div
    class="row"
    @click="rowClick"
  >
    <div
      v-if="thumbnail"
      class="thumbnail thumbnail-img"
      role="img"
      :aria-label="`Media for ${name}`"
      :style="{ backgroundImage: thumbnail }"
    />
    <div
      v-else
      class="thumbnail"
    />
    <div class="name">
      {{ name }}<span><span>-</span>{{ metadata }}</span>
    </div>
    <div class="action-container">
      <icon
        name="arrow"
        class="arrow"
        variant="4fb9de"
      />
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'DeckAttachmentListRow',
  components: { Icon },
  props: {
    card: {
      type: Object,
    },
  },
  emits: ['row-clicked'],
  computed: {
    deck() {
      if (this.card) {
        return this.$store.getters['decks/get'][this.card.assetId];
      }
    },
    metadata() {
      if (this.deck) {
        return this.deck.cardMetadata(this.$store);
      }
    },
    name() {
      if (this.card) {
        return this.card.title;
      }
    },
    thumbnail() {
      if (this.card) {
        const url = this.$store.getters['attachments/get'][this.card.featuredImageId]?.smallThumbnail;
        if (url) {
          return `url("${url}")`;
        }
      }
    },
  },
  methods: {
    rowClick() {
      this.$emit('row-clicked', this.card);
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  .name {
    align-items: center;
    display: flex;
    flex: 1;
    font-size: rem-calc(12);
    margin-left: rem-calc(30);

    span {
      color: #6c747a;

      span {
        margin: 0 rem-calc(8);
      }
    }
  }
  .thumbnail {
    width: 70px;
    height: 39px;
    background-color: #ebedef;
    display: flex;
    align-items: center;
    justify-content: center;

    &.thumbnail-img {
      background-position: center;
      background-size: cover;
    }
  }
  .action-container {
    display: flex;
    align-items: center;
    flex-direction: row;
    min-width: rem-calc(60);

    @include breakpoint(small) {
      flex-direction: column-reverse;
      min-width: rem-calc(40);
    }

    .arrow {
      margin-left: auto;

      @include breakpoint(small) {
        margin-left: 0;
      }
    }
  }
}
</style>
